var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 7a.5.5 0 0 0-.418.226L10.73 21.5H5.5V19a.5.5 0 0 0-.854-.354l-4 4a.5.5 0 0 0 0 .708l4 4A.5.5 0 0 0 5.5 27v-2h7a.5.5 0 0 0 .418-.226L22.27 10.5h4.23v2a.5.5 0 0 0 .83.376l4-3.5a.5.5 0 0 0 .024-.73l-4-4A.5.5 0 0 0 26.5 5v2h-6z",
    fill: "#EDE3F3",
    stroke: "#500D76",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 7a.5.5 0 0 1 .418.226l2.251 3.436a.5.5 0 0 1-.005.556l-1.751 2.564a.5.5 0 0 1-.847-.034L9.71 10.5H5.5v2a.5.5 0 0 1-.83.376l-4-3.5a.5.5 0 0 1-.024-.73l4-4A.5.5 0 0 1 5.5 5v2h6zm15 20v-2h-7a.5.5 0 0 1-.418-.226l-1.256-1.916a.5.5 0 0 1 .005-.556l1.598-2.35a.5.5 0 0 1 .831.007l1.01 1.541h5.23V19a.5.5 0 0 1 .854-.354l4 4a.5.5 0 0 1 0 .708l-4 4A.5.5 0 0 1 26.5 27z",
    fill: "#EDE3F3",
    stroke: "#500D76",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchDashboard);
export default __webpack_public_path__ + "static/media/switchDashboard.45a0ab934fc693ee230805fd0757e49b.svg";
export { ForwardRef as ReactComponent };